import React from "react";
import _ from "lodash";
import { useEffect, useState } from "react";
import { firestore } from "../../../../firebase/firebase";
import LoadingSpinner from "../../../../Public/components/LoadingSpinner/LoadingSpinner";
import AccessibilitySettingsCard from "../../../components/Shop/AccessibilitySettings/AccessibilitySettingsCard";

const AccessibilitySettings = (props) => {
    const [accessDocs, setAccessDocs] = useState([]);
    const [savedConfig, setSavedConfig] = useState(null);
    const [saveState, setSaveState] = useState({});
    const [saveError, setSaveError] = useState(false);
    const [saving, setSaving] = useState(false);
    const [loading, setLoading] = useState(true)

    // Load documents and saved configuration
    useEffect(() => {
        // Load accessibility documents
        const loadDocs = firestore.collection('humanResources')
            .orderBy('name')
            .where('hrType', '==', 'general')
            .where('docType', '==', 'accessibility')
            .get()
            .then(querySnapshot => {
                const response = querySnapshot.docs.map((doc) => {
                    return {
                        ...doc.data(),
                        'docId': doc.id,
                    }
                });
                setAccessDocs(response);
                console.log('accessDocs', response);
                return response;
            });

        // Load saved configuration
        const loadConfig = firestore.collection('shopSettings')
            .doc('accessSettings')
            .get()
            .then(doc => {
                if (doc.exists) {
                    const configData = doc.data();
                    setSavedConfig(configData);
                    console.log('Loaded config:', configData);
                    return configData;
                } else {
                    console.log('No saved configuration found');
                    return null;
                }
            });

        // Wait for both operations to complete
        Promise.all([loadDocs, loadConfig])
            .then(() => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Error loading data:", error);
                setSaveError(true);
                setLoading(false);
            });
    }, [saving]);

    // Handler for saving configuration
    const handleSaveConfig = (configData) => {
        setSaving(true);
        
        // Save to Firestore
        firestore.collection('shopSettings')
            .doc('accessSettings')
            .set(configData, { merge: true })
            .then(() => {
                console.log('Configuration saved successfully');
                setSavedConfig(configData);
                setSaving(false);
            })
            .catch(error => {
                console.error("Error saving configuration:", error);
                setSaveError(true);
                setSaving(false);
            });
    };

    // Handler for canceling save
    const cancelSave = () => {
        // If we have a saved config, reset to that state
        if (savedConfig) {
            setSavedConfig({...savedConfig});
        }
    };

    return !loading && !_.isEmpty(accessDocs)
        ? <React.Fragment>
            <AccessibilitySettingsCard
                accessDocs={accessDocs}
                savedConfig={savedConfig}
                saveState={saveState}
                setSaveState={setSaveState}
                handleSaveConfig={handleSaveConfig}
                cancelSave={cancelSave}
                saving={saving}
                saveError={saveError}
            />
        </React.Fragment>
        : <LoadingSpinner />
};

export default AccessibilitySettings;